exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".MyProjects-module__top___tSKAo{display:grid;justify-content:start;gap:1rem;margin-bottom:2rem;grid-auto-flow:column}@media screen and (min-width:525px){.MyProjects-module__top___tSKAo{grid-auto-flow:column}}.MyProjects-module__page-wrapper___1F0hf h1{margin-top:1.5rem;margin-bottom:1rem}.MyProjects-module__page-wrapper___1F0hf .MyProjects-module__wrapper___eOVVI{display:grid;grid-template-columns:1fr;gap:1.5rem}@media screen and (min-width:525px){.MyProjects-module__page-wrapper___1F0hf .MyProjects-module__wrapper___eOVVI{grid-template-columns:repeat(auto-fill,minmax(400px,1fr))}}", ""]);

// exports
exports.locals = {
	"top": "MyProjects-module__top___tSKAo",
	"page-wrapper": "MyProjects-module__page-wrapper___1F0hf",
	"wrapper": "MyProjects-module__wrapper___eOVVI"
};